import { atom } from "jotai";

export const programmaticNavigationExpectedAtom = atom(false);
programmaticNavigationExpectedAtom.debugLabel =
  "programmaticNavigationExpectedAtom";
